<template>
  <button
    class="BSCButton"
    :class="classType"
    :type="typeButton"
    :disabled="loading || disabled"
  >
    <slot>{{ label }}</slot>
  </button>
</template>

<script>
'use strict'

export default {
  name: 'BSCButton',
  props: {
    label: {
      type: String,
      default: ''
    },
    typeButton: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'normal'
    },
    size: {
      type: String,
      default: 'size-8'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classType() {
      return [
        `is-${this.type}`,
        `is-${this.size}`,
        this.loading ? 'is-loading' : '',
        this.disabled ? 'is-disabled' : ''
      ]
    }
  }
}
</script>
